import Button from './Button'
import WalletIcon from '@components/icons/WalletIcon'
import AcceptTermsModal, {
  TERMS_OF_USE_KEY,
} from '@components/modals/AcceptTermsModal'
import {
  useWalletModal,
  WalletMultiButton,
} from '@solana/wallet-adapter-react-ui'
import { useLocalStorage } from 'hooks/useLocalStorageState'
import { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { clsx } from 'clsx'

const ConnectButton = ({
  className = '',
  isLarge,
  isSecondary,
}: {
  className?: string
  isLarge?: boolean
  isSecondary?: boolean
}) => {
  const { t } = useTranslation('wallet')
  const { visible, setVisible } = useWalletModal()
  const [termsAccepted] = useLocalStorage(TERMS_OF_USE_KEY)
  const [showTermsModal, setShowTermsModal] = useState(false)

  const handleClick = () => {
    if (!termsAccepted) {
      setShowTermsModal(true)
    } else {
      setVisible(!visible)
    }
  }

  return (
    <>
      <Button
        className={clsx('flex items-center', className)}
        onClick={handleClick}
        size={isLarge ? 'large' : 'medium'}
        secondary={isSecondary}
      >
        <WalletMultiButton
          style={{
            backgroundColor: 'transparent',
            padding: 0,
            margin: 0,
            height: '100%',
            color: 'inherit',
            font: 'inherit',
          }}
        >
          <div className="flex items-center">
            <WalletIcon className="mr-2 hidden size-4 sm:block" />
            <span className="text-xs sm:text-sm">{t('connect.button')}</span>
          </div>
        </WalletMultiButton>
      </Button>
      {showTermsModal && (
        <AcceptTermsModal
          isOpen={showTermsModal}
          onClose={() => setShowTermsModal(false)}
        />
      )}
    </>
  )
}

export default ConnectButton
